const defaultViewerCustomSettings = {
  presentationBackgroundColor: '#ebebeb',
  toolbarColor: '#fff',
  toolbarAccentColor: '#f3f3f3',
  toolbarButtonsColor: '#4a76b6',
  buttonTextColor: '#fff',
  dealNameColor: '#333',
  rightPanelBackgroundColor: '#fff',
  rightPanelIconsColor: '#c5c5c5',
  rightPanelAccentColor: '#f3f3f3',
  sectionHeaderColor: '#6c6c6c',
  customSectionHeaderBackgroundColor: '#eee',
  rightPanelTextAndDealRoadshowLogoColor: '#4a76b6',
  topButtonColor: '#355788',
  topButtonTextColor: '#fff',
} as const;

const defaultLoginText = {
  loginPrimaryText: 'Investor Login',
  loginSecondaryText: 'To access a Deal or Non-Deal Roadshow, login below',
} as const;

const defaultFirstTimeText = {
  firstTimeFormPrimaryText: 'Welcome',
  firstTimeFormSecondaryText: 'This is your first time using Deal Roadshow. Please complete the following form.',
} as const;

const defaultViewerDisclaimerSettings = {
  disclaimerBackgroundColor: '#ebebeb',
  disclaimerTileColor: '#fff',
  disclaimerPrimaryTextColor: '#2D2D2D',
  disclaimerButtonColor: '#4A76B6',
  disclaimerButtonTextColor: '#fff',
  disclaimerAccentColor: '#000',
  customMessage: null,
  disclaimerSecondaryTextColor: '#616161',
  disclaimerLinkColor: '#4A76B6',
  disclaimerLabelTextColor: '#8c8c8c',
  ...defaultLoginText,
  ...defaultFirstTimeText,
} as const;

const defaultCreateTopButtonSettings = {
  topButtonType: null,
  topButtonColor: '#355788',
  topButtonTextColor: '#fff',
  topButtonText: null,
} as const;

const dealroadshowBrandingTemplate = {
  viewerCustomSettings: {
    ...defaultViewerCustomSettings,
    viewerDisclaimerCustomizationEnabled: false,
    createTopButton: false,
  },
  viewerDisclaimerSettings: {
    disclaimerLogo: null,
    disclaimerBackgroundImage: null,
    ...defaultViewerDisclaimerSettings,
  },
  createTopButtonSettings: defaultCreateTopButtonSettings,
} as const;

const evercallBrandingTemplate = {
  viewerCustomSettings: {
    presentationBackgroundColor: '#f3f7f6',
    customSectionHeaderText: null,
    customSectionHeaderBackgroundColor: '#f3f7f6',
    customSectionText: null,
    toolbarColor: '#fff',
    toolbarButtonsColor: '#3d9086',
    buttonTextColor: '#fff',
    dealNameColor: '#2d2d2d',
    rightPanelBackgroundColor: '#fff',
    rightPanelIconsColor: '#c0c0c0',
    sectionHeaderColor: '#2d2d2d',
    rightPanelTextAndDealRoadshowLogoColor: '#3d9086',
    toolbarAccentColor: '#f3f7f6',
    rightPanelAccentColor: '#f3f7f6',
    createTopButton: false,
    viewerDisclaimerCustomizationEnabled: true,
  },
  viewerDisclaimerSettings: {
    disclaimerBackgroundColor: '#f3f7f6',
    disclaimerTileColor: '#fff',
    disclaimerPrimaryTextColor: '#2d2d2d',
    disclaimerSecondaryTextColor: '#616161',
    disclaimerLinkColor: '#3d9086',
    disclaimerLabelTextColor: '#8c8c8c',
    disclaimerButtonColor: '#3d9086',
    disclaimerButtonTextColor: '#fff',
    disclaimerAccentColor: '#e7f1ef',
    customMessage: null,
    ...defaultLoginText,
    ...defaultFirstTimeText,
    disclaimerLogo: '/o/download-static-documents/Evercall/evercallLogo.png',
    disclaimerBackgroundImage: '/o/download-static-documents/Evercall/evercallBg.png',
  },
  createTopButtonSettings: defaultCreateTopButtonSettings,
} as const;

const defaultColorSettings = {
  ...defaultViewerCustomSettings,
  ...defaultViewerDisclaimerSettings,
} as const;

const customViewerClassNames = {
  customViewerLayoutContent: 'customViewerLayoutContent',
  customViewerSidebarItem: 'customViewerSidebarItem',
  customViewerSidebarItemActive: 'customViewerSidebarItemActive',
  customViewerSidebarItemLabel: 'customViewerSidebarItemLabel',
  customViewerSidebarHeader: 'customViewerSidebarHeader',
  customViewerPlayer: 'customViewerPlayer',
  customViewerToggleFloatingButton: 'customViewerToggleFloatingButton',
  customViewerSidebarWrapper: 'customViewerSidebarWrapper',
  customViewerSidebar: 'customViewerSidebar',
  customViewerSpinner: 'customViewerSpinner',
  customViewerToolbarInputContainer: 'customViewerToolbarInputContainer',
  customViewerMenuButtonContainer: 'customViewerMenuButtonContainer',
  customViewerTitleEllipsis: 'customViewerTitleEllipsis',
  customViewerToolbarIcon: 'customViewerToolbarIcon',
  customViewerToolbarText: 'customViewerToolbarText',
  customViewerDealName: 'customViewerDealName',
  customViewerToolbar: 'customViewerToolbar',
  customViewerCustomButton: 'customViewerCustomButton',
  customViewerSourceSwitcher: 'customViewerSourceSwitcher',
  customViewerLandscapeButton: 'customViewerLandscapeButton',
  customViewerSidebarButton: 'customViewerSidebarButton',
  customViewerSidebarButtonOutline: 'customViewerSidebarButtonOutline',
  customViewerSidebarExpandButton: 'customViewerSidebarExpandButton',
  customViewerSidebarInnerBorder: 'customViewerSidebarInnerBorder',
  customViewerSidebarText: 'customViewerSidebarText',
  customViewerSidebarLink: 'customViewerSidebarLink',
  customViewerSidebarLogo: 'customViewerSidebarLogo',
} as const;

const viewerDialInNumbers = {
  liveVideoNumber: '+1 (202) 519-5118',
  presentationMediaNumber: '+1 (646) 437-8787',
} as const;

export {
  defaultColorSettings,
  customViewerClassNames,
  viewerDialInNumbers,
  dealroadshowBrandingTemplate,
  evercallBrandingTemplate,
};
